import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import type { TPredictionState } from 'shared/types/features';

const initialState: TPredictionState = {
  visible: false,
};

/* istanbul ignore next */
const predictionSlice = createSlice({
  initialState,
  name: 'prediction',
  reducers: {
    setPredictionVisible: (state, action: PayloadAction<boolean>) => {
      state.visible = action.payload;
    },
  },
});

export const {
  reducer: predictionReducer,
  actions: { setPredictionVisible },
} = predictionSlice;
